var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nullable-radio-group',{attrs:{"labels":_vm.labels,"loading":_vm.cloudCannonContentLoading,"name":((_vm.attestation.attestations.toLowerCase()) + "Yay")},on:{"change":_vm.onNRGChange}})}
var staticRenderFns = []

export { render, staticRenderFns }